import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">最新瓜料</h2>
          <p className="text-foreground-500 text-sm mt-2">网红圈一手八卦黑料实时更新，吃瓜群众速来围观</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
              <div className="relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full aspect-[4/2.6] object-cover object-top"
                  width="400"
                  height="260"
                />
                <span className="absolute top-3 left-3 px-2 py-0.5 bg-background-50/90 text-foreground-800 text-xs rounded whitespace-nowrap">{item.category}</span>
                {item.hot && (
                  <span className="absolute top-3 right-3 px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded whitespace-nowrap">热门</span>
                )}
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-medium text-foreground-950 leading-snug mb-2 line-clamp-2 hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3 mb-3">{item.summary}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{item.time}</span>
                  <span className="text-primary-500 cursor-pointer hover:text-primary-600 transition-colors whitespace-nowrap">阅读全文 <i className="ri-arrow-right-line ml-0.5"></i></span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}